import { CALC_MODELS } from '../../../constants';
import { carbonStrategy } from './carbonStrategy';

export const STRATEGIES = {
  [CALC_MODELS.CARBON]: carbonStrategy,
  [CALC_MODELS.CUSTOM_CO2]: carbonStrategy,
};
